import { RM07_03 } from "./RM07_03";

export const RM07_02 = {
  selectedValueColumn: "Region",
  selectedTitle: "District",
  visual: [
    {
      columns: 12,
      rows: 2,
      visual: {
        id: 1,
        type: "advancedTable",
        colorTheme: "colorTheme1",
        title: "District",
        binding: {
          data: {
            columns: [
              {
                name: "District",
                columnName: "DistrictName",
                width: "450px",
                align: "left",
                sortable: true
              },
              {
                name: "Reached",
                columnName: "ReachedAccounts",
                width: "180px",
                align: "center",
                sortable: true
              },
              {
                name: "Total Accounts",
                columnName: "TotalAccounts",
                width: "180px",
                align: "center",
                sortable: true
              },
              {
                name: "Call Reach",
                columnName: "CallReach",
                width: "180px",
                align: "center",
                sortable: true,
                percent: true
              },
            ],
            title: "DistrictName",
            endpoint: "RM07.2",
            parameters: [
              { key: "CycleCode", value: "CP1" },
              { key: "CycleYear", value: "2026" },
              { key: "RegionCode", value: "RS3" },
              { key: "Region", value: "" }
            ],
          },
          context: {
            point: {
              onClick: RM07_03,
            },
          },
        },
      },
    },
  ],
};